import React, { useState, useEffect } from "react";
import Translation from '../../services/translation.service'; 
import starImg from '../../assets/img/starts.png';
import logoImg from '../../assets/img/logo.png';
import closeImg from '../../assets/img/close.png';
import Helpers from "../../helpers/shared.helper";

const subscriptions = [];
const StickyHeader = () => {
  const [showSticky, setShowSticky] = useState(false);
  const [sticky, setSticky] = useState(true);
  const [translationsKeys, setTranslationsKeys] = useState(Translation.keys ? Translation.keys : {});

  useEffect(() => {
    let showAppDownloadWeb = Helpers.getFeatureDisabled("showAppDownloadWeb");
    if(!showAppDownloadWeb) return;
    const checkVisibility = () => {
      const current = window.location.href;
      const allowedSlugs = [
        '/join/#/bill-payment',
        '/join/#/top_up',
        '/join/#/category',
        '/join#/category',
        '/join#/bill-payment',
        '/join#/top_up'
      ];

      
      const shouldShow = allowedSlugs.some(slug => current.includes(slug));
      setShowSticky(shouldShow);
    };

    checkVisibility(); // Initial load
    window.addEventListener('hashchange', checkVisibility); // Handle route changes

    return () => window.removeEventListener('hashchange', checkVisibility);
  }, []);


  useEffect(() => {
    subscriptions.push(
        Translation.getKeysObsrv().subscribe(data => {
          setTranslationsKeys(data);
        })
    );
    return () => {
        if (subscriptions && subscriptions?.length) {
          for (let subscription of subscriptions) {
            subscription.unsubscribe();
          }
        }
    }
}, []); // eslint-disable-line react-hooks/exhaustive-deps
   

    useEffect(() => {
        const closedTime = localStorage.getItem("modalClosed");
        if (closedTime) {
          const elapsed = Date.now() - parseInt(closedTime, 10);
          if (elapsed < 60000) { // 1 minutes = 60000 milliseconds
            setSticky(false); // false hide banner
          } else {
            localStorage.removeItem("modalClosed");
            setSticky(true); // true show banner
          }
        }
      }, []);
      
      const toggleHandle = () => {
        const element = document.querySelector("main");
        if (element) {
          element.style.opacity = "0";
          element.style.transform = "translateY(-10px)";
          element.style.pointerEvents = "none";
          const handleTransitionEnd = () => {
            setSticky(false);
            localStorage.setItem("modalClosed", Date.now().toString());
            element.removeEventListener("transitionend", handleTransitionEnd);
          };      
          element.addEventListener("transitionend", handleTransitionEnd);
        } else {
          setSticky(false);
          localStorage.setItem("modalClosed", Date.now().toString()); // local storage se time

        }
      };
      if (!showSticky) return null;

    return (<>
            {sticky && ( <main style={{
                    opacity: sticky ? 1 : 0,
                    transform: sticky ? "translateY(0)" : "translateY(-10px)",
                    pointerEvents: sticky ? "auto" : "none"}} className="stickyHeader">
                      <div className="stickyHeader--banner">
                          <div onClick={toggleHandle}><span><img className="stickyHeader--banner-crossimg" src={closeImg} alt="Virgin Mobile App"/></span></div>
                          <div className="stickyHeader--banner-logo">
                              <div><span><img className="stickyHeader--banner-logo-mainlogo" src={logoImg} alt="Virgin Mobile App"/></span></div>
                              <div className="stickyHeader--banner-logo--gap">
                                  <div className="stickyHeader--banner-logo--gap-miantitle">{translationsKeys["stf_app_download_title"] || 'Virgin Mobile App'}</div>
                                  <div className="stickyHeader--banner-logo--gap-subtitle">{translationsKeys["stf_app_download_subtitle"] || 'Virgin Mobile App'}</div>
                                  <div className="stickyHeader--banner-logo--gap-logoStar"><img src={starImg} className="stickyHeader--banner-logo--gap-logoStar--star" alt="Stars"/></div>
                              </div>
                          </div>
                          <div className="stickyHeader--banner-download"><a target="_blank" href={"https://app.adjust.com/1n3rduxh?campaign=Top+Pop-up+banner"} className="stickyHeader--banner-download--link" rel="noopener noreferrer">{translationsKeys["stf_app_download_heading"] || 'Download'}</a></div>
                      </div>
            </main> )}
    </>)
}
export default StickyHeader;